/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationEmailConfigurationModel } from '../../models/organization-email-configuration-model';

export interface AdminFhirIdEmailConfigurationGet$Params {
  fhirId: string;
}

export function adminFhirIdEmailConfigurationGet(http: HttpClient, rootUrl: string, params: AdminFhirIdEmailConfigurationGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<OrganizationEmailConfigurationModel>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdEmailConfigurationGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<OrganizationEmailConfigurationModel>;
    })
  );
}

adminFhirIdEmailConfigurationGet.PATH = '/Admin/{fhirId}/EmailConfiguration';
